import { IFormErrors } from '@interfaces/IFormsErrors';

export interface IPeriodsChangesState {
  isLoading: boolean;
  success: boolean;
  errors: IFormErrors | null;
}

export const initialPeriodsChangesState: IPeriodsChangesState = {
  isLoading: false,
  success: false,
  errors: null,
};
